import React from 'react';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT } from '../../../constants';

import { sendUnsubscribeRequest } from '../../../services/unsubscribe/actions';

import HeadComponent from '../../HeadComponent';
import Breadcrumb from '../../breadcrumb/Breadcrumb';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import { LoadingComponent } from '../../loading/LoadingComponent';

import './UnsubscribePage.scss';

export class UnsubscribePage extends React.Component {
    componentDidMount() {
        const { sendUnsubscribeRequest, email } = this.props;
        sendUnsubscribeRequest(email);
    }

    renderMessage() {
        const { i18n, errorMessage } = this.props;
        if (errorMessage) {
            return <p className="error">{i18n.ERROR_MESSAGE}</p>;
        }
        return <p className="success">{i18n.SUBMIT_SUCCEEDED}</p>;
    }

    render() {
        const { i18n, requestSubmit } = this.props;

        return (
            <main role="main" className="conteneur conteneur-mobile" id="p-desabonnement">
                <HeadComponent
                    title={i18n.TITLE}
                    description={i18n.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.UNSUBSCRIBE_PATH}`}
                />
                <Breadcrumb
                    defaultRoute
                    routes={[
                        {
                            label: i18n.BREADCRUMB,
                            route: PATH.UNSUBSCRIBE_PATH
                        }
                    ]}
                />
                <h1>{i18n.PAGE_TITLE}</h1>
                {requestSubmit ? <LoadingComponent /> : this.renderMessage()}
            </main>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const email = ownProps.match && ownProps.match.params.email;

    return {
        i18n: state.i18n.page.UNSUBSCRIBE,
        BRAND_NAME: state.i18n.common.BRAND_NAME,
        errorMessage: state.unsubscribe.error,
        requestSubmit: state.unsubscribe.fetching,
        successSubmit: state.unsubscribe.successUnsubscribeRequestSubmit,
        email: email
    };
};

const mapDispatchtoProps = {
    sendUnsubscribeRequest
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchtoProps)(UnsubscribePage),
    PrimaryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/unsubscribe/UnsubscribePage.js